import { type SerializedCompStructure } from '@wix/document-services-types'

import { type RichTextBoxProps } from '../types'

export function assertRichTextBoxProps(
  props: NonNullable<SerializedCompStructure['props']>,
): asserts props is RichTextBoxProps {
  const TYPE: RichTextBoxProps['type'] = 'RichTextBoxProperties'
  if (props.type !== TYPE) {
    throw new Error('Not rich-text-box props.')
  }
}
